import { configurePersistable } from 'mobx-persist-store';

configurePersistable({
  storage: typeof window !== 'undefined' ? window.localStorage : undefined,
});

export * from 'mobx-persist-store';
